export default __webpack_public_path__ + "static/media/screen3.3c69da95.png";